import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from "react";
import GlobalSearchModel from "./GlobalSearchModel";
import { IconSearch, IconCircleClose } from "@/components/icon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import "./index.less";
import Bus from "@/utils/bus";
import { UAParser } from "ua-parser-js";
import { SearchType } from "@/services/SearchService";
import { Input } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import AddressBook from "@/pages/AddressBook";
import { analysisLog } from "@/utils/logAnalytics";
import { formatHotkeyToIcon, isFocusEnv } from "@/utils";
interface GlobalSearchType {
  activeKey?: SearchType;
  inputMarginLeft?: number;
}
let timer: any = null;
export default function GlobalSearch(props: GlobalSearchType) {
  const { focusSDK, isHomePage, localConfigData } = useContext<GlobalContextConfig>(GlobalContext);
  const { activeKey = SearchType.All } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [keyWord, setKeyWord] = useState<string>("");
  const [isChange, setIsChange] = useState(false);
  const [searchHotKey, setSearchHotkey] = useState("");
  const searchHotKeyRef = useRef<string>("");
  let inputRef: any = useRef({});
  // const widthRef = useRef(0);
  const location = useLocation();
  // const widthBox = document.getElementById("global-search-container")?.offsetWidth;
  // const widthBox = useMemo(() => {
  //   if (!isHomePage) {
  //     return 0;
  //   }
  //   if (!widthRef.current) {
  //     const width = document.getElementById("global-search-container")?.offsetWidth || 0;
  //     widthRef.current = width;
  //   }
  //   return widthRef.current;
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location?.pathname, isHomePage]);

  // useEffect(() => {
  //     document.addEventListener('click', () => {
  //         setKeyWord('');
  //         setVisible(false);
  //     });
  //     return () => {
  //         document.removeEventListener('click', () => {
  //             setKeyWord('');
  //             setVisible(false);
  //         });
  //     };
  // }, []);

  const openGlobalSearch = useCallback(() => {
    console.log("222222222", "e===========>");
    inputRef.current && inputRef.current.focus();
    setVisible(!visible);
  }, [visible]);

  const isMac = useMemo(() => {
    let platform = focusSDK.getDeviceInfo().platform;
    if (platform === "web") {
      let uaParser = new UAParser();
      let os = uaParser.getOS();
      return (os?.name as string).indexOf("Mac") > -1 || (os?.name as string).indexOf("iOS") > -1;
    }
    return platform === "darwin";
  }, [focusSDK]);

  const formatSearchHotkey = (key: string) => {
    console.log(key, isMac);
    searchHotKeyRef.current = key;
    if (isMac) {
      setSearchHotkey(formatHotkeyToIcon(key));
      return;
    }
    setSearchHotkey(key);
  };

  useEffect(() => {
    if (isFocusEnv()) {
      const key = localConfigData.searchHotkey;
      formatSearchHotkey(key);
    } else {
      formatSearchHotkey(isMac ? "Cmd+F" : "Ctrl+F");
    }
  }, [focusSDK, isMac, localConfigData.searchHotkey]);

  const onSearchHotkeyChange = useCallback((data: { hotkey: string }) => {
    formatSearchHotkey(data.hotkey);
  }, []);

  useEffect(() => {
    Bus.on("hotkeyReg", onSearchHotkeyChange);
    return () => {
      Bus.off("hotkeyReg", onSearchHotkeyChange);
    };
  }, []);

  useEffect(() => {
    const keySearch = (e: KeyboardEvent) => {
      // if (focusSDK.getDeviceInfo().platform !== 'web') {
      //     return;
      // }
      if (!searchHotKeyRef.current) return;
      const auxiliaryKey = [
        e.ctrlKey ? "Ctrl" : "",
        e.altKey ? "Alt" : "",
        e.shiftKey ? "Shift" : "",
        e.metaKey ? "Meta" : ""
      ].filter((t) => t);
      const contentArr = [...auxiliaryKey];
      const someKeys = ["Ctrl", "Alt", "Shift", "Meta", "Control"];
      // mac下禁止使用快捷键option
      let publicKey = someKeys.indexOf(e.key) < 0 ? e.key.toLocaleUpperCase() : "";
      if (e.code.startsWith("Key") && publicKey) {
        publicKey = e.code.replace("Key", "");
      }

      if (auxiliaryKey.length && publicKey) {
        contentArr.push(publicKey);
      }
      const hotkey = isMac
        ? contentArr
            .join("+")
            .replace("Ctrl", "Control")
            .replace("Alt", "Option")
            .replace("Meta", "Cmd")
        : contentArr.join("+");
      if (hotkey === searchHotKeyRef.current) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!visible) {
          openGlobalSearch();
        } else {
          setVisible(false);
        }
      }
      // let keyFlag = !!e.ctrlKey;
      // if (isMac) {
      //   keyFlag = !!e.metaKey;
      // }
      // // console.log(e, 'e===========>');
      // if (keyFlag && e.keyCode === 70) {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   e.stopImmediatePropagation();
      //   openGlobalSearch();
      // }
    };
    const handlePressCtrlF = () => {
      const pathname = location.pathname;
      if (pathname === "/third_apps") {
        Bus.emit("handleWvSearch");
      } else {
        const ctrlFAliasArr = ["Cmd+F", "Command+F", "Ctrl+F"];
        !isMac && ctrlFAliasArr.push("Control+F");
        console.log("searchHotKeyRef.current", searchHotKeyRef.current);
        if (ctrlFAliasArr.includes(searchHotKeyRef.current)) {
          if (!visible) {
            openGlobalSearch();
          } else {
            setVisible(false);
          }
        }
        // if (hotkey === searchHotKeyRef.current) {
        //   e.preventDefault();
        //   e.stopPropagation();
        //   e.stopImmediatePropagation();
        //   if (!visible) {
        //     openGlobalSearch();
        //   } else {
        //     setVisible(false);
        //   }
        // }
      }
    };
    console.log("keydown=================>");
    window.addEventListener("keydown", keySearch);
    focusSDK.on("openGlobalSearch", openGlobalSearch);
    focusSDK.on("press-ctrl+f", handlePressCtrlF);
    return () => {
      focusSDK.off("openGlobalSearch", openGlobalSearch);
      focusSDK.off("press-ctrl+f", handlePressCtrlF);
      window.removeEventListener("keydown", keySearch);
    };
  }, [focusSDK, openGlobalSearch, isMac, visible, location]);
  const onHideGlobalSearch = useCallback(() => {
    setVisible(false);
  }, []);
  useEffect(() => {
    Bus.on("onHideGlobalSearch", onHideGlobalSearch);
    return () => {
      Bus.off("onHideGlobalSearch", onHideGlobalSearch);
    };
  }, [onHideGlobalSearch]);

  useEffect(() => {
    if (!visible) {
      Bus.emit("search:clear-continuous-keyword");
    }
  }, [visible]);
  const setOnChange = useCallback((val: string) => {
    setSearchValue(val);
  }, []);

  useEffect(() => {
    if (!isChange) {
      setKeyWord(searchValue);
    }
  }, [isChange, searchValue]);

  const clstag = useCallback(() => {
    console.log("current_pathname", location.pathname);
    const pathname = location.pathname;
    // if (pathname === '/address_list') {
    //     analysisLog('xtbg_add_home_1637657110163', '40');
    // }
    if (pathname.startsWith("/messages")) {
      // analysisLog('Xtbg_Msg_Home', 'Search');
      analysisLog("xtbg_home_search_1641454991771", "9");
      return;
    }
    switch (pathname) {
      case "/address_list":
        analysisLog("xtbg_home_search_1641454991771", "38");
        break;
      case "/projects":
        analysisLog("xtbg_home_search_1641454991771", "34");
        break;
      case "/calendar":
        analysisLog("xtbg_home_search_1641454991771", "35");
        break;
      case "/joyspace/home/recent":
        analysisLog("xtbg_home_search_1641454991771", "36");
        break;
      case "/third_apps":
        analysisLog("xtbg_home_search_1641454991771", "37");
        break;
    }
  }, [location?.pathname]);
  const DOM = useMemo(() => {
    return (
      <div
        className="global-search-container"
        id="global-search-container"
        style={{ width: 400 }}
      >
        {/* 搜索 */}
        {!visible && (
          <div
            className="global-search-input cursor-outline"
            style={{
              display: "flex",
              // justifyContent: "space-between",
              alignItems: "center"
            }}
            onClick={(event: any) => {
              setVisible(true);
              clstag();
              inputRef.current && inputRef.current.focus();
              event.nativeEvent.stopImmediatePropagation();
            }}
          >
            <div style={{
              display: "flex",
              alignItems: "center"
            }}>{IconSearch}</div>
            <span>快速搜索{searchHotKey ? `（${searchHotKey}）` : ""}</span>
          </div>
        )}
        <div
          className={
            visible
              ? "search-global-modal-mask  search-global-translateY-mask"
              : "search-global-modal-mask"
          }
          onClick={(e) => {
            setVisible(false);
          }}
        />
        {/* 弹出框 */}
        <div
          className={
            visible ? "search-global-modal  search-global-translateY" : "search-global-modal"
          }
          onClick={(event: any) => {
            event.nativeEvent.stopImmediatePropagation();
          }}
        >
          {/* input容器 */}
          <div
            className="global-search-input_container"
          >
            {/* input */}
            <div
              className="global-search-input input-left"
              style={{
                width: 400
              }}
            >
              <div style={{
                display: "flex",
                alignItems: "center"
              }}>{IconSearch}</div>
              <Input
                ref={inputRef}
                value={searchValue}
                // defaultValue={keyWord}
                maxLength={60}
                placeholder={`快速搜索${searchHotKey ? `（${searchHotKey}）` : ""}`}
                onChange={(event: any) => {
                  event.persist();
                  const val = event.target.value;
                  setOnChange(val);
                }}
                onCompositionStart={(e) => {
                  setIsChange(true);
                }}
                onCompositionEnd={(event: any) => {
                  setOnChange(event.target.value);
                  setIsChange(false);
                }}
              />
              {searchValue && !isChange && (
                <span
                  onClick={(event: any) => {
                    setSearchValue("");
                    inputRef.current && inputRef.current.focus();
                    event.nativeEvent.stopImmediatePropagation();
                  }}
                >
                  {IconCircleClose}
                </span>
              )}
            </div>
          </div>
          <GlobalSearchModel
            keyWord={keyWord}
            isChange={isChange}
            activeKey={activeKey}
            setSearchGlobalValue={(val: string) => {
              setSearchValue(val);
            }}
          />
        </div>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeKey,
    isChange,
    isMac,
    keyWord,
    searchValue,
    setOnChange,
    visible,
    clstag,
    searchHotKey
  ]);
  return DOM;
}
